module.exports = __webpack_public_path__ + "static/media/ic_homework_release.4b71d4e7.png";